<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
let self = {};
export default {
  name: "TableSubnetResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      companyId: "",
      accountSearchKey: [],
      accountName: "",
      columns: [
        {
          title: this.$t("RAM.TENCENT.SUBNET.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.TENCENT.SUBNET.subnetId"),
          key: "subnetId"
        },
        {
          title: this.$t("RAM.TENCENT.SUBNET.subnetName"),
          key: "subnetName"
        },
        {
          title: this.$t("RAM.TENCENT.SUBNET.vpcId"),
          key: "vpcId"
        },
        {
          title: this.$t("RAM.TENCENT.SUBNET.cidrBlock"),
          key: "cidrBlock"
        },
        {
          title: this.$t("RAM.TENCENT.SUBNET.availableIpCount"),
          key: "availableIpCount"
        },
        {
          title: this.$t("RAM.TENCENT.SUBNET.region"),
          key: "regionName"
        }
      ],
      tableData: []
    };
  },
  created() {
    this._handleCompanyId = val => { this.companyId = val; };
    this._handleAccountSearchKey = val => { this.accountSearchKey = val; };
    this._handleAccountName = val => { this.accountName = val; };
    eventBus.$on("companyId", this._handleCompanyId);
    eventBus.$on("accountSearchKey", this._handleAccountSearchKey);
    eventBus.$on("accountName", this._handleAccountName);
    self = this;
  },
  methods: {
    showAll() {
      self.current = 1;
      self.getData();
    },
    getData() {
      self.$api.resourceManagement
        .selectTencentSubnetByPage({
          companyId: self.companyId,
          accountIds: self.accountSearchKey,
          accountName: self.accountName,
          pageNum: self.current,
          pageSize: self.pageSize
        })
        .then(res => {
          this.tableData = res.data.records;
          this.current = res.data.current;
          this.dataTotal = res.data.total;
        });
    },
    changePage(current) {
      this.current = current;
      this.getData();
    },
    changeSize(pageSize) {
      this.pageSize = pageSize;
      this.getData();
    }
  },
  beforeDestroy() {
    eventBus.$off("companyId", this._handleCompanyId);
    eventBus.$off("accountSearchKey", this._handleAccountSearchKey);
    eventBus.$off("accountName", this._handleAccountName);
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/tencent/subnet/TableSubnetResource.vue